<!-- 
    描述：审计费用 -- 新增申请内容
    时间：2021-07-12
    Created by zl
-->
<template>
    <div class="fee-dialog-layout" :class="{ 'padding-style': routeQuery == 'check' || routeQuery == 'view' }">
        <div class="auditArea" v-show="auditVisble">
            <el-button size="mini" type="primary" v-show="routeQuery == 'check'" @click="approvalDialog(true)">审核</el-button>
            <el-button size="mini" v-if="routeQuery == 'check'" @click="backApproval">取消</el-button>
        </div>
        <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(item, index) in cardShowList" :key="item.type" :title="'# ' + (index + 1) + ' ' + item.title" :name="index + 1 + ''">
                <template v-if="item.type == 'baseInfo'">
                    <div class="view-form">
                        <el-row>
                            <el-col :span="24">
                                <el-col :span="4">工程项目名称：</el-col>
                                <el-col :span="20">{{ feeForm.projectName }}</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">合同依据：</el-col>
                                <el-col :span="8">
                                    <span class="blue-text" @click="viewContract(feeForm, 'list')">
                                        {{ feeForm.contractName }}
                                        <!-- {{ "( " + feeForm.tips + " )" }} -->
                                    </span>
                                </el-col>
                                <el-col :span="4">合同类型：</el-col>
                                <el-col :span="8">{{
                                    feeForm.contractTypeName || "无"
                                    }}</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">合同金额：</el-col>
                                <el-col :span="8">
                                    <span v-if="!!feeForm.amount">
                                        {{ feeForm.isEstimate ? "估值 " : "" }}
                                        {{ feeForm.amount + " 元" || "无" }}
                                    </span>
                                </el-col>
                                <template v-if="dealFile(feeForm.templateId) !== ''">
                                    <el-col :span="4" v-if="dealFile(feeForm.templateId)">相关文件：</el-col>
                                    <el-col :span="8" v-if="dealFile(feeForm.templateId)">
                                        <span class="blue-text" @click="jumpHref">{{
                                            dealFile(feeForm.templateId)
                                            }}</span>
                                    </el-col>
                                </template>
                                <!-- <template v-if="feeForm.contractType === '1012002'">
                                    <el-col :span="4">总计费金额：</el-col>
                                    <el-col :span="8">
                                        <span v-if="!!feeForm.totalAmount">
                                            {{ feeForm.totalAmount + " 元" || "无" }}
                                        </span>
                                    </el-col>
                                </template> -->
                            </el-col>
                            <el-col :span="24">
                                <p class="split-line"></p>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-col :span="4">关联任务：</el-col>
                                <el-col :span="8" v-if="!!feeForm.taskName">
                                    {{ feeForm.taskName }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                                <el-col :span="4">报告编号：</el-col>
                                <el-col :span="8" v-if="!!feeForm.reportNo">
                                    {{ feeForm.reportNo }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">任务单号：</el-col>
                                <el-col :span="8" v-if="!!feeForm.acceptNo">
                                    {{ feeForm.acceptNo }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                                <el-col :span="4">委托日期：</el-col>
                                <el-col :span="8" v-if="!!feeForm.entrustTime">
                                    {{ feeForm.entrustTime.substr(0, 11) }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                            <el-col :span="24">
                                <p class="split-line"></p>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">相关合同：</el-col>
                                <el-col :span="8">
                                    <span v-for="(item, index) in viewContractList" :key="'相关合同：' + index" class="blue-text mr10" @click="viewContract(item)">
                                        {{ item.sname }}
                                        {{ index == viewContractList.length - 1 ? "" : "," }}
                                    </span>
                                </el-col>
                                <el-col :span="4">相关合同金额：</el-col>
                                <el-col :span="8">
                                    <span v-if="!!relateContract.amount">
                                        {{ relateContract.isEstimate ? "估值 " : "" }}
                                        {{ relateContract.amount + " 元" || "无" }}
                                    </span>
                                </el-col>
                            </el-col>
                            <el-col :span="24">
                                <p class="split-line"></p>
                            </el-col>
                        </el-row>

                        <template v-if="feeForm.type === '1012002'">
                            <el-row v-for="(m, n) in feeForm.totalBillAmountDetails" :key="'totalBillAmountDetails' + n">
                                <el-col :span="24">
                                    <el-col :span="4">计费基数：</el-col>
                                    <el-col :span="8">{{ m.chargeBaseName }}</el-col>
                                    <el-col :span="4">计费基数金额：</el-col>
                                    <el-col :span="8">{{
                                        m.billBaseAmount + " 元" || "无"
                                        }}</el-col>
                                </el-col>
                                <el-col :span="24">
                                    <el-col :span="4">费率：</el-col>
                                    <el-col :span="3">{{ m.rate + " %" || "无" }}</el-col>
                                    <el-col :span="2" class="bg-col">优惠折扣：</el-col>
                                    <el-col :span="3">{{ m.discount + " %" || "无" }}</el-col>
                                    <el-col :span="4">计费金额：</el-col>
                                    <el-col :span="8">{{
                                        m.billAmount + " 元" || "无"
                                        }}</el-col>
                                </el-col>
                                <el-col :span="24">
                                    <p class="split-line"></p>
                                </el-col>
                            </el-row>
                        </template>
                        <!-- <el-col :span="24">
                            <el-col :span="4">合同金额：</el-col>
                            <el-col :span="feeForm.contractType == '1012002' ? 8 : 20">
                                <span v-if="!!feeForm.amount">
                                    {{ feeForm.isEstimate ? '估值   ' : '' }}
                                    {{ feeForm.amount + '  元' || '无' }}
                                </span>
                            </el-col>
                            <el-col :span="4"
                                    v-if="feeForm.contractType == '1012002'">计费基数：</el-col>
                            <el-col :span="8"
                                    v-if="feeForm.contractType == '1012002'">{{ feeForm.chargeBase || '无' }}
                            </el-col>
                        </el-col>
                        <el-col :span="24"
                                v-if="feeForm.contractType == '1012002'">
                            <el-col :span="4">费率：</el-col>
                            <el-col :span="8">{{ feeForm.rate + '%' || '无' }}</el-col>
                            <el-col :span="4">优惠折扣：</el-col>
                            <el-col :span="8">{{ feeForm.discount + '%' || '无' }}</el-col>
                        </el-col> -->
                        <el-col :span="24">
                            <el-col :span="4">标题：</el-col>
                            <el-col :span="20">{{ feeForm.title }}</el-col>
                        </el-col>
                        <!-- 跟踪审计任务类型 -->
                        <template v-if="feeForm.auditType === '1006004001'">
                            <el-col :span="24">
                                <el-col :span="4">工程状态：</el-col>
                                <el-col :span="8" v-if="!!feeForm.proStateName">
                                    {{ feeForm.proStateName }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                                <el-col :span="4">付款比例：</el-col>
                                <el-col :span="8" v-if="!!feeForm.payRate">
                                    {{ feeForm.payRate + ' %' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">累计完成投资额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.finishAmount">
                                    {{ feeForm.finishAmount + ' 万元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                                <el-col :span="4">该合同累计已申请金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.applyTotalMoney">
                                    {{ feeForm.applyTotalMoney + ' 元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">该合同累计已付款金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.payTotalMoney">
                                    {{ feeForm.payTotalMoney + ' 元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                                <el-col :span="4">本次申请金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.applyAmount">
                                    {{ feeForm.applyAmount + ' 元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                        </template>
                        <!-- 结算审计任务类型 -->
                        <template v-if="feeForm.auditType === '1006004002'">
                            <el-col :span="24">
                                <el-col :span="4">送审金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.submitAmount">
                                    {{ feeForm.submitAmount + ' 元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                                <el-col :span="4">审定金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.auditAmount">
                                    {{ feeForm.auditAmount + ' 元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">甩项金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.jiltAmount">
                                    {{ feeForm.jiltAmount + ' 元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                                <el-col :span="4">审减率：</el-col>
                                <el-col :span="8" v-if="!!feeForm.reduceRate">
                                    {{ feeForm.reduceRate + ' %' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">该合同累计已申请金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.applyTotalMoney">
                                    {{ feeForm.applyTotalMoney + ' 元' }}
                                </el-col>
                                <el-col :span="4">该合同累计已付款金额：</el-col>
                                <el-col :span="8" v-if="!!feeForm.payTotalMoney">
                                    {{ feeForm.payTotalMoney + ' 元' }}
                                </el-col>
                                <el-col :span="8" v-else>无</el-col>
                            </el-col>
                            <el-col :span="24">
                                <el-col :span="4">本次申请金额：</el-col>
                                <el-col :span="20" v-if="!!feeForm.applyAmount">
                                    {{ feeForm.applyAmount + ' 元' }}
                                </el-col>
                                <el-col :span="20" v-else>无</el-col>
                            </el-col>
                        </template>
                        <el-col :span="24">
                            <el-col :span="4">申请说明：</el-col>
                            <el-col :span="20">{{
                                feeForm.explanation || "无"
                                }}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="4">附件：</el-col>
                            <el-col :span="20">
                                <span v-if="fileList.length > 0" class="blue-text">
                                    <template v-for="(item, index) in fileList">
                                        <FileName :fileName="item.fileName" :filePath="item.filePath"></FileName>
                                        <span class="mr10" v-if="index !== fileList.length - 1">,</span>
                                    </template>
                                </span>
                                <span v-else>无</span>
                            </el-col>
                        </el-col>
                    </div>
                </template>
                <template v-if="item.type == 'acceptInfo'">
                    <div class="view-form">
                        <el-col :span="24">
                            <el-col :span="4">收款单位：</el-col>
                            <el-col :span="8">{{ feeForm.sname }}</el-col>
                            <el-col :span="4">收款账号：</el-col>
                            <el-col :span="8">{{ feeForm.account }}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="4">开户行：</el-col>
                            <el-col :span="8">{{ feeForm.openBankName }}</el-col>
                            <el-col :span="4">支行：</el-col>
                            <el-col :span="8">{{ feeForm.subBank || "无" }}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="4">发票：</el-col>
                            <el-col :span="20">
                                <span v-if="fileObj.aid && fileObj.aid != ''" class="blue-text">
                                    <FileName :fileName="fileObj.fileName" :filePath="fileObj.filePath"></FileName>
                                </span>
                                <span v-else>无</span>
                            </el-col>
                        </el-col>
                    </div>
                </template>
                <template v-if="item.type == 'unitInfo'">
                    <div class="view-form">
                        <el-col :span="24">
                            <el-col :span="4">申请人：</el-col>
                            <el-col :span="8">{{ feeForm.applyUser }}</el-col>
                            <el-col :span="4">申请单位：</el-col>
                            <el-col :span="8">{{ feeForm.unitName }}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="4">申请时间：</el-col>
                            <el-col :span="20">{{ feeForm.createDate }}</el-col>
                        </el-col>
                    </div>
                </template>
                <template v-if="item.type == 'truePayInfo'">
                    <el-row :gutter="10">
                        <el-form ref="payForm" :model="payForm" label-width="140px" :rules="payRules" size="small">
                            <el-col :span="12">
                                <el-form-item label="支付金额" prop="payAmount">
                                    <el-input v-model="payForm.payAmount" placeholder="请输入..." autocomplete="off">
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="付款状态" prop="status">
                                    <el-select v-model="payForm.status" placeholder="请选择...">
                                        <el-option v-for="(item, index) in statusList" :key="item.value + index" :label="item.sname" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="feeForm && feeForm.overpaymentAmount >= 0">
                                <el-form-item class="mb0 red">
                                    该笔申请已超付金额：<span>{{
                                        feeForm.overpaymentAmount
                                        }}</span>
                                    元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="实际付款时间" prop="payTime">
                                    <el-date-picker v-model="payForm.payTime" type="datetime" clearable placeholder="请选择..."></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="付款方式" prop="payType">
                                    <el-select v-model="payForm.payType" placeholder="请选择...">
                                        <el-option v-for="item in projectDict.fkfs" :key="item.value" :label="item.sname" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="上传银行单据">
                                    <myUpload ref="upload" width="200px" height="110px" tableName="audit_pay_record" assortment="audit_pay_record" uploadType="0" :maxNum="1"></myUpload>
                                </el-form-item>
                            </el-col>
                        </el-form>
                    </el-row>
                </template>
                <template v-if="item.type == 'checkInfo'">
                    <vxe-table align="center" auto-resize border :data="checkData" highlight-current-row highlight-hover-row show-overflow="tooltip" show-header-overflow="tooltip">
                        <vxe-table-column field="userName" title="审批人/移交人"></vxe-table-column>
                        <vxe-table-column field="shortName" title="审批单位" header-align="center" align="left">
                            <template #default="{ row }">
                                <el-tooltip effect="dark" :content="row.deptName" placement="top">
                                    <span class="vxe-cell--label">{{ row.shortName }}</span>
                                </el-tooltip>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="handleDate" title="审批时间/移交时间"></vxe-table-column>
                        <vxe-table-column field="payRate" title="付款比例" header-align="center" align="right">
                            <template #default="{ row }">
                                <span v-if="row.status == '1001026002'">{{ row.payRate }} %</span>
                                <span v-if="row.status == '1001026003'">-</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="finishVal" title="完成产值（元）" header-align="center" align="right">
                            <template #default="{ row }">
                                <span v-if="row.status == '1001026002'">{{ row.finishVal }}</span>
                                <span v-if="row.status == '1001026003'">-</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="approveMount" title="审批金额（元）" header-align="center" align="right">
                            <template #default="{ row }">
                                <span v-if="row.status == '1001026002'">{{ row.approveMount }}</span>
                                <span v-if="row.status == '1001026003'">-</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="status" title="审批结果">
                            <template #default="{ row }">
                                <span v-if="row.status == '1001026002'">通过</span>
                                <span v-else-if="row.status == '1001026003'">驳回</span>
                                <span v-else>-</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="remark" title="审批意见" header-align="center" align="left"></vxe-table-column>
                        <vxe-table-column field="" title="备注">
                            <template #default="{ row, rowIndex }">
                                <span v-if="row.status == '1001026041'">移交</span>
                                <span v-else-if="(row.status == '1001026002') && (['1001026016', '1001026017', '1001026018', '1001026019'].includes(feeForm.status)) && (rowIndex === checkData.length - 1)">结束流程</span>
                                <span v-else>-</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </template>
                <template v-if="item.type == 'historyInfo'">
                    <vxe-table align="center" auto-resize border :data="historyData" highlight-current-row highlight-hover-row show-overflow="tooltip" show-header-overflow="tooltip">
                        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
                        <vxe-table-column field="payAmount" title="支付金额（元）" header-align="center" align="right"></vxe-table-column>
                        <vxe-table-column field="payTypeName" title="付款方式"></vxe-table-column>
                        <vxe-table-column field="payTime" title="实际付款时间" width="160"></vxe-table-column>
                        <vxe-table-column field="fileName" title="银行单据">
                            <template #default="{ row }">
                                <FileName :fileName="row.fileName" :filePath="row.filePath" onlyDownload></FileName>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </template>
            </el-collapse-item>
        </el-collapse>

        <!-- 审核弹窗 -->
        <el-dialog :title="auditObj.title" :visible.sync="auditObj.show" center :before-close="auditCancel" append-to-body :close-on-click-modal="false" :width="auditObj.width">
            <el-form :model="auditForm" ref="auditForm" label-width="150px" size="small">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="审核结果：" prop="status" :rules="requiredRule">
                            <el-radio-group v-model="auditForm.status" @change="radioChange">
                                <el-radio label="1001026002">通过</el-radio>
                                <el-radio label="1001026003">驳回</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="auditForm.status == '1001026002'">
                        <el-form-item label="异常原因：" prop="reasons">
                            <el-select v-model="auditForm.reasons" placeholder="请选择" clearable :disabled="currentRow.reasons != ''">
                                <el-option v-for="item in projectDict.ycyy"
                                        :key="item.value"
                                        :label="item.sname"
                                        :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="auditForm.status == '1001026002'">
                        <el-form-item label="付款比例：" prop="payRate" :rules="numRule">
                            <el-input v-model="auditForm.payRate" placeholder="请输入...">
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="auditForm.status == '1001026002'">
                        <el-form-item label="完成产值：" prop="finishVal" :rules="moneyRule">
                            <el-input v-model="auditForm.finishVal" placeholder="请输入...">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="auditForm.status == '1001026002'">
                        <el-form-item label="审批金额：" prop="approvalAmount" :rules="moneyRule">
                            <el-input v-model="auditForm.approvalAmount" placeholder="请输入..." @input="moneyChange">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="showTips" class="red">
                        <el-form-item class="mb0">
                            {{showTips ? `申请金额 ${this.feeForm.applyAmount} 元，审批金额大于申请金额！` : ''}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="审核意见：" prop="remark" :rules="auditForm.status == '1001026003' ? requiredRule : []" class="mb30">
                    <el-input type="textarea" :autosize="{ minRows: 6 }" :maxlength="200" show-word-limit placeholder="请输入内容" v-model="auditForm.remark">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <div class="tip-box">
                        <p><i class="el-icon-warning"></i>备注：驳回，必须在审核意见内填写驳回理由。</p>
                        <p class="left-indent">审核结束：该审批流程到此结束。</p>
                        <p class="left-indent">继续提交审核：继续为该审批流程选择下一步的提交审核对象。</p>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="btn" @click="auditCancel" size="small">取消</el-button>
                <el-button class="btn btn-success" size="small" @click="auditConfirm" :loading="auditObj.loading">审核结束</el-button>
                <el-button class="btn" type="primary" size="small" :disabled="auditForm.status == '1001026003'" @click="handOther" :loading="auditObj.loading">继续提交审核</el-button>
            </div>
        </el-dialog>

        <!-- 查看合同 -->
        <el-dialog title="查看合同" :visible.sync="contractShow" :close-on-click-modal="false" center append-to-body top="6vh" width="1200px">
            <ContractView v-if="contractShow" class="h600" doType="view" :projectName="feeForm.projectName" :projectId="currentRow.projectId" :contractObj="contractObj"></ContractView>
        </el-dialog>

        <!-- 移交他人审核 -->
        <AuditPersonList v-if="auditShow" ref="AuditPersonList" :rowData="currentRow" doType="audit" :auditForm="auditForm" @closeDia="closeDia"></AuditPersonList>
    </div>
</template>
<script>
import { mapState } from "vuex";
import {
    getSubmitAdd,
    feeApplyEcho,
    paymentRegister,
    selectRelationContract,
    selectApproveRecordById,
} from "api/approval/approval";
import { getFiles } from "api/upload/upload";
import ContractView from "@/views/FeeManagement/ContractView";
import fileName from "@/components/file/fileName";
import AuditPersonList from '@/views/Common/AuditPersonList'
export default {
    name: "FeeForm",
    components: { ContractView, fileName, AuditPersonList },
    props: {
        type: {
            type: String,
            default: "",
        },
        selectObj: {
            type: Object,
            default: () => {
                return {};
            },
        },
        statusList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            activeNames: ["1", "2", "3", "4", "5", "6"],
            feeForm: {}, //费用基础信息
            //实际支付信息
            payForm: {
                projectId: "", //项目id
                contractId: "", //合同id
                applyId: "", //申请记录id
                payAmount: "", //支付金额
                status: "", //付款状态
                payTime: "", //实际付款时间
                payType: "", //付款方式（码表）
                applyUser: "", //申请人
            },
            historyData: [], //该合同历史付款记录数据
            checkData: [], //审核信息数据
            payRules: {
                payAmount: [
                    { required: true, message: "不能为空..." },
                    {
                        pattern: /(^[\d]|^[1-9][\d]{0,12})($|[\.][\d]{0,2}$)/,
                        message: "请填写正确的金额,小数点前最多十三位,以及最多两位小数",
                    },
                ],
                status: [{ required: true, message: "不能为空..." }],
                payTime: [{ required: true, message: "不能为空..." }],
                payType: [{ required: true, message: "不能为空..." }],
            },
            // 弹窗对象
            auditObj: {
                title: "审核",
                show: false,
                width: "1000px",
                loading: false,
            },
            auditForm: {
                status: "1001026002",
                remark: "",
                approvalAmount: "",
                payRate: "",
                finishVal: "",
                reasons: ""
            },
            requiredRule: [{ required: true, message: '不能为空...' }],
            moneyRule: [
                { required: true, message: "不能为空..." },
                {
                    pattern: /(^[\d]|^[1-9][\d]{0,12})($|[\.][\d]{0,2}$)/,
                    message: "请填写正确的金额,小数点前最多十三位,以及最多两位小数",
                },
            ],
            numRule: [
				{ required: true, message: '不能为空...', trigger: 'blur' },
				{
					pattern: /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/,
					message: '最大值为100,最多两位小数,不包含100',
				},
			],
            cardList: [{
                    type: "baseInfo",
                    title: "申请信息",
                },
                {
                    type: "acceptInfo",
                    title: "收款方信息",
                },
                {
                    type: "unitInfo",
                    title: "申请单位信息",
                },
                {
                    type: "truePayInfo",
                    title: "实际支付信息",
                },
                {
                    type: "checkInfo",
                    title: "审核信息",
                },
                {
                    type: "historyInfo",
                    title: "付款记录",
                },
            ],
            fileObj: {}, //发票附件对象
            fileList: [],   // 附件列表
            viewContractList: [], //相关合同
            relateContract: {},
            contractList: [], //合同列表
            contractShow: false,
            contractObj: {},
            showTips: false,
            auditShow: false
        };
    },
    created() {
        // 回显信息
        this.feeApplyEcho();
        if (this.type == "pay") {
            this.activeNames = ["5", "6"];
        }
        this.auditForm.reasons = this.currentRow.reasons
    },
    methods: {
        // 移交其他人员
        handOther() {
            this.auditShow = true
            this.$refs.auditForm.validate((valid) => {
                if (valid) {
                    setTimeout(() => {
                        this.$refs.AuditPersonList.auditPersonObj.show = true
                    }, 200)
                    return
                }
                this.$message.error('请完善表单！')
            })
        },
        // 接收弹窗关闭
        closeDia(data) {
            this.auditShow = false
            if (data) {
                this.backApproval()
            }
        },
        // 获取审批信息
        getApprovalList() {
            selectApproveRecordById({
                id: this.currentRow.id,
                module: 1,
            }).then((res) => {
                this.checkData = res.data
                if (this.type == 'pay' || this.type == 'view') {
                    this.checkData = this.selectObj.approvalRecordList
                    // 审批信息数量 > 0 时， 设置默认支付信息
                    if (this.checkData.length > 0) {
                        let _index = this.checkData.length - 1
                        this.payForm.payAmount = this.checkData[_index].approveMount
                        this.payForm.status = '1001026018'
                        this.payForm.payType = '1023001'
                        this.payForm.payTime = this.checkData[_index].handleDate
                    }
                }
                if (this.routeQuery == 'check') {
                    // 处理数据
                    this.approvalDialog(false)
                }
            })
        },
        // 回显信息
        feeApplyEcho() {
            let params = {
                projectId: "",
                busId: "",
                type: this.$route.query.menu == "approval" ? 1 : 2,
            };
            if (this.type != "") {
                params.projectId = this.selectObj.projectId;
                params.busId = this.selectObj.id;
            } else {
                params.projectId = this.currentRow.projectId;
                params.busId = this.currentRow.busId;
            }
            feeApplyEcho(params).then((res) => {
                this.feeForm = this.$utils.clone(res.data, true);
                this.auditForm.approvalAmount = this.feeForm.applyAmount;
                this.historyData = res.data.payRecordList;
                if (res.data.payAmountEcho >= 0) {
                    this.payForm.payAmount = res.data.payAmountEcho;
                }
                // 相关合同
                this.feeForm.contractIds = this.feeForm.contractIds.split(",");
                // 获取发票
                this.getFiles();
                // 获取附件
                this.getFeeFiles();
                // 获取合同列表
                this.getContractList();
                // 获取审批信息
                this.getApprovalList()
            });
        },
        // 处理数据
        approvalDialog(handler) {
            this.auditObj.show = handler
            if (this.checkData.length > 0) {
				for(let i = this.checkData.length -1;i >= 0;i--) {
                    if(this.checkData[i].approveMount && this.checkData[i].status == '1001026002'){
                        this.auditForm.payRate = this.checkData[i].payRate
                        this.auditForm.finishVal = this.checkData[i].finishVal
                        this.auditForm.approvalAmount = this.checkData[i].approveMount
                        break
                    }   
                }
                this.auditForm.payRate = this.auditForm.payRate ? this.auditForm.payRate : this.feeForm.payRate
                this.auditForm.finishVal = this.auditForm.finishVal ? this.auditForm.finishVal : this.feeForm.totalAmount
                this.auditForm.approvalAmount = this.auditForm.approvalAmount ? this.auditForm.approvalAmount : this.feeForm.applyAmount
                this.auditForm.reasons = this.currentRow.reasons || ''
            }
        },
        // 获取合同列表
        getContractList() {
            let projectId = "";
            this.type != "" ?
                (projectId = this.selectObj.projectId) :
                (projectId = this.currentRow.projectId);
            selectRelationContract({
                projectId,
            }).then((res) => {
                this.contractList = res.data;
                // 获取合同类型
                let obj = this.contractList.find((x) => x.id == this.feeForm.contractId);
                this.feeForm.contractType = obj?.type; //合同类型
                if (!!this.feeForm.contractIds) {
                    let _item = this.contractList.find(
                        (x) => x.id == this.feeForm.contractIds
                    );
                    this.relateContract = _item ? _item : {};
                    _item ? this.viewContractList.push(_item) : "";
                }
            });
        },
        // 金额校验
        moneyChange(data) {
            if (parseFloat(data) > this.feeForm.applyAmount) {
                this.showTips = true
                return
            }
            this.showTips = false
        },
        // 查看合同
        viewContract(data, type) {
            this.contractObj = this.$utils.clone(data, true);
            if (type == "list") {
                let obj = this.contractList.find(
                    (x) => x.id == this.contractObj.contractId
                );
                this.contractObj.id = obj ? obj.id : "";
                this.contractObj.projectId = obj.projectId
            }
            this.contractShow = true;
        },
        // 查看合同
        radioChange(data) {
            if (data == '1001026003') {
                this.showTips = false
            }
            setTimeout(() => {
                this.$refs.auditForm.clearValidate()
            }, 100)
        },
        // 保存或提交
        doSave() {
            //1:保存 2：提交
            let params = this.$utils.clone(this.payForm, true);
            params.projectId = this.selectObj.projectId;
            params.contractId = this.selectObj.contractId;
            params.applyId = this.selectObj.id;
            this.$refs.payForm[0].validate((valid) => {
                if (valid) {
                    paymentRegister(params)
                        .then((res) => {
                            this.$refs.upload[0].fileSend(
                                res.data.id,
                                this.selectObj.projectId,
                                () => {
                                    this.$emit("btnLoding", false, "success");
                                },
                                () => {
                                    this.$emit("btnLoding", false, "success");
                                }
                            );
                        })
                        .catch(() => {
                            this.$emit("btnLoding", false, "fail");
                        });
                } else {
                    this.$message.error("请完善表单！");
                    this.$emit("btnLoding", false, "fail");
                }
            });
        },
        // 获取发票
        getFiles() {
            getFiles({
                aid: this.feeForm.id,
                assortment: "audit_fee_apply",
                source: "1",
                tableName: "audit_fee_apply",
            }).then((res) => {
                this.fileObj = res.data.length > 0 ? res.data[0] : {};
            });
        },
        // 获取附件
        getFeeFiles() {
            getFiles({
                aid: this.feeForm.id,
                assortment: "audit_fee_file",
                source: "1",
                tableName: "audit_fee_apply",
            }).then((res) => {
                this.fileList = res.data.length > 0 ? res.data : [];
            });
        },
        //审核取消
        auditCancel() {
            this.auditObj.show = false;
            this.showTips = false
            this.$refs.auditForm.resetFields()
        },
        //审核提交
        auditConfirm() {
            let params = this.$utils.clone(this.auditForm, true);
            // 如果是审核驳回， 那么必须填写审核意见
            this.$refs.auditForm.validate((valid) => {
                if (valid) {
                    if (params.status == '1001026003') {
                        delete params.approvalAmount
                        delete params.finishVal
                        delete params.payRate
                        delete params.reasons
                    }
                    this.auditObj.loading = true;
                    // 需要带上数据的 busId
                    params.busId = this.currentRow.busId;
                    getSubmitAdd(params).then((res) => {
                        this.auditObj.loading = false;
                        this.backApproval();
                    });
                } else {
                    this.$message.error("请完善表单！")
                }
            })
        },
        // 返回
        backApproval() {
            this.$router.push({ path: "/redirect/approval" });
        },
        // 处理附件
        dealFile(data) {
            let msg = "";
            switch (data) {
                case "1437668987788988416":
                    msg = "国家计委1283号文《工程咨询收费标准》";
                    this.jumpUrl =
                        "https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=gczxsfbz";
                    break;
                case "1437668987805765632":
                    msg = "计价格[2002]10号，《工程勘察设计收费管理规定》";
                    this.jumpUrl =
                        "https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=gcsjsfbz";
                    break;
                case "1437668987818348544":
                    msg = "皖价服[2007]86号《工程造价咨询服务收费标准》";
                    this.jumpUrl =
                        "https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=gczjfwsfbz";
                    break;
                case "1437668987839320064":
                    msg = "发改价格[2007]670号，《建设工程监理与相关服务收费管理规定》";
                    this.jumpUrl =
                        "https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=sgjlsfbz";
                    break;
                case "1437668987851902976":
                    msg = "计价格[2002]1980号，《招标代理服务收费管理暂行办法》";
                    this.jumpUrl =
                        "https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=zbdlsfbz";
                    break;
                default:
                    msg = "";
                    this.jumpUrl = "";
            }
            return msg;
        },
        // 跳转
        jumpHref() {
            window.open(this.jumpUrl, "_blank");
        },
    },
    computed: {
        ...mapState("dict", {
            projectDict: (state) => state.projectDict,
        }),
        //审核按钮可见
        auditVisble() {
            return this.$route.query.menu === "approval";
        },
        // 获取路由里的type
        routeQuery() {
            return this.$route.query.type;
        },
        // 缓存的当前行对象
        currentRow() {
            return this.$getSessionItem("currentRow") ?
                JSON.parse(this.$getSessionItem("currentRow")) :
                {};
        },
        // 要展示的 card
        cardShowList() {
            let menu = this.type;
            let arr = this.cardList.concat();
            let menuArr = [];
            let showMenu = [];
            switch (menu) {
                case "pay":
                    menuArr = [
                        "baseInfo",
                        "acceptInfo",
                        "unitInfo",
                        "truePayInfo",
                        "checkInfo",
                        "historyInfo",
                    ];
                    break;
                case "view":
                    menuArr = [
                        "baseInfo",
                        "acceptInfo",
                        "unitInfo",
                        "checkInfo",
                        "historyInfo",
                    ];
                    break;
                default:
                    menuArr = ["baseInfo", "acceptInfo", "unitInfo", "checkInfo"];
            }
            let obj = {};
            arr.map((x) => {
                if (menuArr.includes(x.type)) {
                    if (this.type == "pay" && x.type == "checkInfo") {
                        obj = x;
                        obj.title = "审核基本信息";
                    } else {
                        showMenu.push(x);
                    }
                }
            });
            if (this.type == "pay") {
                showMenu.splice(3, 0, obj);
            }
            return showMenu;
        },
    },
    beforeRouteLeave(to, from, next) {
        this.$getSessionItem("currentRow") ? this.$removeSessionItem("currentRow") : "";
        if (this.$route.query.menu == "approval" && to.path != "/redirect/approval") {
            this.$getSessionItem("activeName") ?
                this.$removeSessionItem("activeName") :
                "";
        }
        next();
    },
};

</script>
<style lang="less" scoped>
.fee-dialog-layout {
    .el-collapse {
        border-bottom: none;

        .el-collapse-item {
            margin-bottom: 15px;
        }

        /deep/ .el-collapse-item__header {
            padding-left: 15px;
            font-size: 16px;
            background-color: #eff6fe;
        }

        /deep/ .el-collapse-item__wrap {
            border-bottom: none;
        }

        /deep/ .el-collapse-item__content {
            padding: 15px;
        }
    }

    .el-form-item {
        margin-bottom: 15px !important;
    }

    .mb0 {
        margin-bottom: 0px !important;
    }

    .red {
        color: red;
    }

    .view-form {
        .el-col-24 {
            display: flex;
        }

        .el-col-4,
        .el-col-2,
        .el-col-3,
        .el-col-8,
        .el-col-20 {
            padding: 5px 0!important;
        }

        .el-col-4,
        .bg-col {
            text-align: right;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }

    .blue-text {
        color: #2671cc;
    }

    .auditArea {
        position: absolute;
        right: 10px;
        top: 65px;
        height: 30px;
        background-color: white;
    }
}

.padding-style {
    height: 100%;
    overflow-y: auto;
    padding: 30px 20px;
}

.el-form-item {
    margin-bottom: 15px !important;
}

.btn {
    padding: 0 50px !important;
}

.h600 {
    height: 600px;
}

.red {
    color: red;
}

.mb0 {
    margin-bottom: 0px !important;

    /deep/ .el-form-item__content {
        line-height: 30px !important;
        font-size: 12px;
    }
}

.split-line {
    width: 100%;
    height: 5px;
    margin: 5px 0;
    border-bottom: 2px dashed #d7d7d7;
}

.tip-box {
    line-height: 25px;
    background: #ECF5FF;
    border-radius: 5px;
    border: 1px solid #D9ECFF;
    color: #419EFF;
    padding: 5px 15px;

    .left-indent {
        text-indent: 3.5rem;
    }
}

</style>

<style lang="less">
.vxe-table--tooltip-wrapper {
    z-index: 9999 !important;
}

</style>
